/* eslint-disable no-param-reassign */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import get from "lodash-es/get";

// Config
import { instrumentationKey } from "../../config/apiConfig";

const reactPlugin = new ReactPlugin();
let appInsights = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
  /**
   * Initialize the Application Insights class
   * @param {Object} history - client's browser history, supplied by the withRouter HOC
   * @return {void}
   */
  const initialize = (history, currentUser) => {
    if (!history) {
      throw new Error("Could not initialize Telemetry Service");
    }

    // reactPlugin = new ReactPlugin();

    appInsights = new ApplicationInsights({
      config: {
        // The MK.IO streaming endpoint's CORS preflight doesn't allow the correlation headers,
        // so adding them to manifest requests stops every video from playing. Setting this
        // replaces the SDK's default list, so the blob storage domains are kept here too.
        correlationHeaderExcludedDomains: [
          "*.streaming.mediakind.com",
          "*.blob.core.windows.net",
          "*.blob.core.chinacloudapi.cn",
          "*.blob.core.cloudapi.de",
          "*.blob.core.usgovcloudapi.net"
        ],
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        extensionConfig: { [reactPlugin.identifier]: { history } },
        extensions: [reactPlugin],
        instrumentationKey,
        maxBatchInterval: 0
      }
    });

    appInsights.loadAppInsights();
    const telemetryInitializer = envelope => {
      envelope.tags["ai.cloud.role"] = "WebApp";

      if (currentUser) {
        envelope.ext.user.id = currentUser.accountIdentifier;
        envelope.data.userType = get(currentUser, "idToken.userType", "");
      }
    };

    appInsights.addTelemetryInitializer(telemetryInitializer);
  };

  return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
